import type {WidgetType} from "constants/WidgetConstants";
import * as React from "react";
import type {WidgetProps, WidgetState} from "widgets/BaseWidget";
import TaroWidget from "widgetsTaro";
import {ValidationTypes} from "constants/WidgetValidation";
import type {Stylesheet} from "entities/AppTheming";
import {DefaultAutocompleteDefinitions} from "widgets/WidgetUtils";
import type {AutocompletionDefinitions} from "widgets/constants";
import TSwitchWidget from "../component";
import {DerivedPropertiesMap} from "../../../utils/WidgetFactory";
import {FontStyleTypes} from "constants/WidgetConstants";
import {fontSizeOptions} from "../../../pages/Editor/ThemePropertyPane/controls/ThemeFormControl";
import contentConfig from "./contentConfig";
import styleConfig from "./styleConfig";

class TSwitch extends TaroWidget<TSwitchWidgetProps, WidgetState> {
  constructor(props: TSwitchWidgetProps) {
    super(props);
  }
  static getAutocompleteDefinitions(): AutocompletionDefinitions {
    return {
      value: "string",
      isVisible: DefaultAutocompleteDefinitions.isVisible,
    };
  }

  static getPropertyPaneContentConfig = contentConfig;
  static getPropertyPaneStyleConfig = styleConfig;

  static getDerivedPropertiesMap(): DerivedPropertiesMap {
    return {
      getValue: `{{ this.value }}`
    };
  }
  static getDefaultPropertiesMap(): Record<string, string> {
    return {
      value: "defaultValue"
    };
  }

  static getStylesheetConfig(): Stylesheet {
    return {
      borderRadius: "{{appsmith.theme.borderRadius.appBorderRadius}}",
      boxShadow: "none",
      fontSize: "{{appsmith.theme.form.label.fontSize}}",
      color: "{{appsmith.theme.form.label.fontColor}}",
      fontStyle: "{{appsmith.theme.form.label.fontStyle}}",
      backgroundColor: "{{appsmith.theme.colors.primaryColor}}",
      bgColor: "{{appsmith.theme.form.inputBorder.bgColor}}",
    };
  }
  updateWidgetProperty = (propertyValues: string) => {
    if (!this.props.isDirty) {
      this.props.updateWidgetMetaProperty("isDirty", true);
    }
    this.props.updateWidgetMetaProperty("value", propertyValues);
  }

  getPageView() {
    return (
      <TSwitchWidget {...this.props} updateWidgetProperty={this.updateWidgetProperty} />
    );
  }


  static getWidgetType(): WidgetType {
    return "AT_SWITCH_WIDGET";
  }
}

export interface TSwitchWidgetProps extends WidgetProps {
  value: any[];
  label: string;
  onClick?: any;
  borderRadius: string;
  boxShadow?: string;
}

export default TSwitch;
